import {
  FAV_DEFAULT_SORT_ORDER,
  FAV_SORT_OPTIONS,
  FavSortByOptions,
  IFS_DEFAULT_SORT_ORDER,
  IFS_SORT_OPTIONS,
} from '@constants/profile-fav-sort';
import { ElasticSearch } from '@interfaces/models/elasticSearch';

const isValidSortOption = <T extends string>(options: T[], sortOrder: string): sortOrder is T => {
  return options.includes(sortOrder as T);
};

export const getValidFavSortOrder = (sortOrder: string): FavSortByOptions => {
  return isValidSortOption(FAV_SORT_OPTIONS, sortOrder) ? (sortOrder as FavSortByOptions) : FAV_DEFAULT_SORT_ORDER;
};

export const getValidIfsSortOrder = (sortOrder: string): ElasticSearch['sortBy'] => {
  return isValidSortOption(IFS_SORT_OPTIONS, sortOrder)
    ? (sortOrder as ElasticSearch['sortBy'])
    : IFS_DEFAULT_SORT_ORDER;
};
